var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-button',{staticClass:"play-button",attrs:{"round":""},on:{"click":function($event){return _vm.$emit('click', $event)}}},[_c('base-icon',{attrs:{"color":"var(--palette-unchanged-bg)","font-size":40}},[_vm._v("sci-play")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }